import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';
import { Constants } from '../../shared/Constants';

@Injectable()
export class WaybillService {

  constructor(private http:HttpClient,) { }

  createWaybill(data){
    let headers = new HttpHeaders()
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

    return this.http.post(Constants.URL_BACKEND+'/waybill/', data , { headers : headers })
  }

  getWaybills(){
    let headers = new HttpHeaders()
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

    return this.http.get(Constants.URL_BACKEND+'/waybill/', { headers : headers })
  }

  getOneWaybill(id){
    let headers = new HttpHeaders()
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

    return this.http.get(Constants.URL_BACKEND+'/waybill/'+id , { headers : headers })
  }

  electronicWaybill(id){
    let headers = new HttpHeaders()
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

    return this.http.get(Constants.URL_BACKEND+'/electronicWaybill/'+id , { headers : headers })
  }

  anulate(id){
    let headers = new HttpHeaders()
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

    return this.http.get(Constants.URL_BACKEND+'/anulateWaybill/'+id , { headers : headers })
  }

  delete(id){
    let headers = new HttpHeaders()
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

    return this.http.delete(Constants.URL_BACKEND+'/deleteWaybill/'+id, { headers : headers })
  }

  editWaybill(data){
    let headers = new HttpHeaders()
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

    return this.http.put(Constants.URL_BACKEND+'/waybill/', data , { headers : headers })
  }

}



// WEBPACK FOOTER //
// ./src/app/system/services/waybill.service.ts